/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Filter3 = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 18 17">
      <path d="M17 1.5L1 1.5C.723857625 1.5.5 1.27614237.5 1 .5.723857625.723857625.5 1 .5L17 .5C17.2761424.5 17.5.723857625 17.5 1 17.5 1.27614237 17.2761424 1.5 17 1.5zM15 6.5L3 6.5C2.72385763 6.5 2.5 6.27614237 2.5 6 2.5 5.72385763 2.72385763 5.5 3 5.5L15 5.5C15.2761424 5.5 15.5 5.72385763 15.5 6 15.5 6.27614237 15.2761424 6.5 15 6.5zM13 11.5L5 11.5C4.72385763 11.5 4.5 11.2761424 4.5 11 4.5 10.7238576 4.72385763 10.5 5 10.5L13 10.5C13.2761424 10.5 13.5 10.7238576 13.5 11 13.5 11.2761424 13.2761424 11.5 13 11.5zM11 16.5L7 16.5C6.72385763 16.5 6.5 16.2761424 6.5 16 6.5 15.7238576 6.72385763 15.5 7 15.5L11 15.5C11.2761424 15.5 11.5 15.7238576 11.5 16 11.5 16.2761424 11.2761424 16.5 11 16.5z" />
    </BaseSvgIcon>
  )
}

export default Filter3
